/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Form, Input, Select } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import QRCode from 'qrcode.react'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

import ConstituentSelect from '../../../components/Custom/ConstituentSelect'
import Checkbox from '../../../components/Custom/CustomCheckbox'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			selectedConstituent: null,
			generatedQRCode: null,
			visitorData: null
		}

		this.handleGenerateQR = this.handleGenerateQR.bind(this)
		this.handleDownloadQRCode = this.handleDownloadQRCode.bind(this)
	}

	handleGenerateQR(e) {
		e.preventDefault()
		const { form } = this.props
		const { selectedConstituent } = this.state

		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			if (values.is_resident && selectedConstituent) {
				values = Object.assign({}, values, {
					name: `${selectedConstituent.first_name || ''} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name || ''}`,
					gender: selectedConstituent.gender,
					address: `${selectedConstituent.house_no || ''} ${selectedConstituent.street || ''} ${selectedConstituent.address || ''} ${selectedConstituent.purok_name || ''}`,
					mobile_number: selectedConstituent.contact_no
				})
			}
			if (!values.purpose_visit) {
				values = Object.assign({}, values, {
					purpose_visit: 'Barangay transaction'
				})
			}

			console.log('values', values)
			this.setState({ visitorData: values, generatedQRCode: JSON.stringify(values) })
		})
	}

	handleDownloadQRCode (e) {
		e.preventDefault()
		const { visitorData } = this.state

		const visitorSplittedName = visitorData.name.split(' ').join('_')
		const visitorFilename = `${visitorSplittedName}_${moment().format('YYYYMMDDHHmmss')}`
		const canvas = document.getElementById('generated-qr')
		const pngUrl = canvas
			.toDataURL('image/png')
			.replace('image/png', 'image/octet-stream')
		let downloadLink = document.createElement('a')
		downloadLink.href = pngUrl
		downloadLink.download = `${visitorFilename}.png`
		document.body.appendChild(downloadLink)
		downloadLink.click()
		document.body.removeChild(downloadLink)
	}

	render() {
		const { selectedConstituent, generatedQRCode, visitorData } = this.state
		const { AuthStore, form } = this.props
		const { barangay_uid } = AuthStore
		const { getFieldDecorator, getFieldValue, resetFields } = form
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">Visitor's QR Code Generator</li>
								</ol>
							</div>
							<h4 className="page-title">Visitor's QR Code Generator</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Form onSubmit={this.handleGenerateQR}>
									<Row gutter={32} >
										<Col md={12} sm={24}>
											<Row style={{ marginBottom: -35 }}>
												<Form.Item label=''>
													{ getFieldDecorator('is_resident', {
														//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: false,
															message: 'This field is required.'
														}]
													})
													(
														<Checkbox 
															style={{ color: 'red' }}
														>Resident?
														</Checkbox>
													)}
												</Form.Item>
											</Row>
											{
												(getFieldValue('is_resident')) &&
												<Row>
													<Form.Item label='Name'>
														{ getFieldDecorator('constituent_uid', {
															//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
															rules: [{
																required: true,
																message: 'This field is required.'
															}, {
																validator: (rule, value, callback) => {
																	if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																		callback('only white space detected.')
																	}
																	callback()
																}
															}]
														})
														(
															<ConstituentSelect
																barangay_uid={barangay_uid}
																placeholder='Select Constituent'
																onSelectedItem={(item) => {
																	if (item) {
																		this.setState({ selectedConstituent: item })
																	} else {
																		this.setState({ selectedConstituent: null })
																	}
																}}
															/>
														)}
													</Form.Item>
												</Row>
											}
											{
												(!getFieldValue('is_resident')) &&
												<Row>
													<Form.Item label='Name'>
														{ getFieldDecorator('name', {
															//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
															rules: [{
																required: true,
																message: 'This field is required.'
															}, {
																validator: (rule, value, callback) => {
																	if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																		callback('only white space detected.')
																	}
																	callback()
																}
															}]
														})
														(
															<Input placeholder='Enter visitor name' />
														)}
													</Form.Item>
												</Row>
											}
											{
												(!getFieldValue('is_resident')) &&
												<Row>
													<Form.Item label='Address'>
														{ getFieldDecorator('address', {
															//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
															rules: [{
																required: true,
																message: 'This field is required.'
															}, {
																validator: (rule, value, callback) => {
																	if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																		callback('only white space detected.')
																	}
																	callback()
																}
															}]
														})
														(
															<Input placeholder='Enter visitor address' />
														)}
													</Form.Item>
												</Row>
											}
											{
												(!getFieldValue('is_resident')) &&
												<Row gutter={16}>
													<Col md={12} sm={24}>
														<Form.Item label='Mobile Number'>
															{ getFieldDecorator('mobile_number', {
																//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
																rules: [{
																	required: false,
																	message: 'This field is required.'
																}, {
																	validator: (rule, value, callback) => {
																		if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																			callback('only white space detected.')
																		}
																		callback()
																	}
																}]
															})
															(
																<Input placeholder='Enter mobile number' />
															)}
														</Form.Item>
													</Col>
													<Col md={12} sm={24}>
														<Form.Item label='Gender'>
															{ getFieldDecorator('gender', {
																//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
																rules: [{
																	required: false,
																	message: 'This field is required.'
																}]
															})
															(
																<Select
																	placeholder='Select Gender'
																>
																	<Select.Option value='Male'>Male</Select.Option>
																	<Select.Option value='Female'>Female</Select.Option>
																</Select>
															)}
														</Form.Item>
													</Col>
												</Row>
											}
											<Row>
												<Form.Item label='Purpose of Visit'>
													{ getFieldDecorator('purpose_visit', {
														//initialValue: (selectedComplain) ? selectedComplain.complainant_name : null,
														rules: [{
															required: false,
															message: 'This field is required.'
														}, {
															validator: (rule, value, callback) => {
																if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
																	callback('only white space detected.')
																}
																callback()
															}
														}]
													})
													(
														<Input.TextArea rows={4} placeholder='Enter purpose of visit' />
													)}
												</Form.Item>
											</Row>
											<Row style={{ textAlign: 'center' }}>
												<button onClick={this.handleGenerateQR} className="btn btn-danger dropdown-toggle waves-effect waves-light" type="submit">
													<i className="mdi mdi-settings mr-2"></i> Generate QR Code
												</button>
												<button style={{ marginLeft: '20px' }} onClick={()=> {
													resetFields()
													this.setState({ generatedQRCode: null, visitorData: null })
												}} type="button" className="btn btn-outline-secondary waves-effect">Clear</button>
											</Row>
										</Col>
										<Col md={12} sm={24}>
											<Row type='flex' justify='center'>
											{
												generatedQRCode &&
												<Col sm={24} md={12}>
													<Row style={{ textAlign: 'center' }}>
														<h4>Generated QR Code</h4>
														<span>{visitorData.name}</span>
														<br/>
														<QRCode 
															id='generated-qr' 
															value={generatedQRCode}
															size={290}
															level={'H'}
															includeMargin={true}
														/>
														<br/>
														<a style={{ color: 'blue', cursor: 'pointer' }} onClick={this.handleDownloadQRCode}>Download QR Code</a>
													</Row>
												</Col>
											}
											</Row>
										</Col>
									</Row>
								</Form>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}


const composed = compose(
	Form.create({ name: 'qrcode-generator' }),
	inject('AuthStore'),
	observer
)

export default composed(Index)
